import { SortDirType } from "../../../common/SortDirType";
import { SortParams } from "../../../common/SortParams";

export const sortByFields = [
  { label: "Check In Date", value: "CHECK_IN_DATE" },
  { label: "Location Name", value: "LOCATION_NAME" },
  { label: "Supplier Name", value: "SUPPLIER_NAME" },
  { label: "Asset Type", value: "ASSET_TYPE" },
  { label: "Order Number", value: "ORDER_NUMBER" },
  { label: "Driver First Name", value: "DRIVER_FIRST_NAME" },
  { label: "Driver Last Name", value: "DRIVER_LAST_NAME" },
  { label: "Container Number", value: "CONTAINER_NUMBER" },
  { label: "Trailer Number", value: "TRAILER_NUMBER" },
  { label: "Chassis Number", value: "CHASSIS_NUMBER" },
  { label: "Truck License Plate Number", value: "TRUCK_LICENSE_PLATE_NUMBER" }
] as const satisfies Array<{label: string, value: string}>;

export type BuyerInventorySortByType = typeof sortByFields[number]['value'];

export interface BuyerInventorySortParams extends SortParams {
  sortBy?: BuyerInventorySortByType;
  sortDir?: SortDirType
}